<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-route"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div id="previewPanel" class="col-md-9 custom-col-3 custom-middle-panel">
        <div *ngIf="!hasOperators && !loadingOperators && !verificationUnavailable" class="alert alert-custom-dark"
             role="alert">
          <div class="row">
            <div class="col-md-1">
              <i class="fa fa-exclamation-circle fa-2x"></i>
            </div>
            <div class="col-md-11 font-weight-bold font-size-14">
              {{ "MESSAGE.DOCUMENT-NOT-HAVE-THE-NECESSARY-SIGNATURES" | translate }}
            </div>
          </div>
        </div>
        <div class="table-responsive  {{operatorsInfo.length > 3 ? 'scroll-table' : 'scroll-table1'}}"
             *ngIf="hasOperators && !loadingOperators">
          <table class="table-sm">
            <thead class="thead-custom-dark">
            <tr>
              <th scope="col">#</th>
              <th scope="col"></th>
              <th scope="col">{{ "TABLE.HEADER.OPERATION" | translate }}</th>
              <th scope="col">{{ "TABLE.HEADER.BY" | translate }}</th>
              <th scope="col">{{ "TABLE.HEADER.CERTIFYING-ENTITY" | translate }}</th>
              <th scope="col">TSA</th>
              <th scope="col">{{ "TABLE.HEADER.TIME-STAMP" | translate }}</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let operatorInfo of operatorsInfo; let index=index">
              <th scope="row">{{index + 1}}</th>
              <td class="custom-th">
                <i class="fa {{getClassOperatorInfo(operatorInfo)}}" (click)="showModalSignatureInfo(operatorInfo)"></i>
              </td>
              <td>{{operatorInfo.operationDescription | translate}}</td>
              <td>{{operatorInfo.operatorName}}</td>
              <td>{{operatorInfo.issuerCertName}}</td>
              <td>{{operatorInfo.tsa}}</td>
              <td class="mw-138">{{operatorInfo.certainDateTime}}</td>
              <td>
              <span class="badge badge-info"
                    [hidden]="hasntCertificate(operatorInfo)"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Ver más"
                    (click)="openModalSeeCertificateDetail(index)">
              {{ "BUTTON.VIEW-MORE" | translate }}
              </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="{{getClassMaxHeight(operatorsInfo)}}" *ngIf="!reloadingPdf">
          <div class="row mt-2">
            <div id="previewPanel1"
                 class="col-md-12 custom-col-3 custom-panel">
              <ng2-pdfjs-viewer #pdfViewer
                                [pdfSrc]="urlStream"
                                zoom="auto"
                                [download]="false"
                                [print]="false"
                                [openFile]="false"
                                [showSpinner]="true"
                                [viewBookmark]="false"
                                scroll="V"
                                (onDocumentLoad)="loadComplete($event)"
                                viewerId="documentVisor">
              </ng2-pdfjs-viewer>
            </div>
          </div>
        </div>
      </div>
      <div id="traceabilityPanel"
           class="col-md-3 custom-col-3 {{traceabilitiesisHasMoreThan15 ? 'scrollable' : 'scrollable1'}}">
        <ul class="list-group list-group-flush">
          <li class="list-group-item font-weight-bold row"
              style="font-size: 14px;">{{ "TITLE.ATTACHMENTS" | translate }}</li>
          <li class="list-group-item display-contents row mt-1" *ngFor="let resource of resources; let index=index"
              style="font-size: 12px;">
            <a href="javascript:" (click)="selectAttachment(resource)"><p class="overflow-ellipsis"
                                                                           data-toggle="tooltip" data-placement="top"
                                                                           title="{{resource.fileName}}">
              <i class="fa fa-file-pdf icon-color-green" aria-hidden="true"
                 style="font-size: 16px;"></i> {{ resource.fileName }}</p>
            </a>
          </li>
        </ul>
        <!--        </div>-->
        <ul class="list-group list-group-flush">
          <li class="list-group-item font-weight-bold">
            <div class="row">
              {{ "TITLE.TRACEABILITY" | translate }}
            </div>
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-11">
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         (change)="onItemChangeTraceability($event, TRACEABILITY_SIGNATURE_COMPONENT)"
                         id="interactionSigningComponentCheckbox">
                  <label class="custom-control-label" style="font-weight: normal!important;"
                         for="interactionSigningComponentCheckbox">{{ "LABEL.VIEW-INTERACTION-SIGNATURE-COMP" | translate }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-11">
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         (change)="onItemChangeTraceability($event, TRACEABILITY_VISUALIZACION)"
                         id="traceabilityVisualizationCheckbox">
                  <label class="custom-control-label" style="font-weight: normal!important;"
                         for="traceabilityVisualizationCheckbox">{{ "LABEL.VIEW-DISPLAY-TRACEABILITY" | translate }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-11">
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         (change)="onItemChangeTraceability($event, TRACEABILITY_MAILING)"
                         id="traceabilitySendToMailCheckbox">
                  <label class="custom-control-label" style="font-weight: normal!important;"
                         for="traceabilitySendToMailCheckbox">{{ "LABEL.VIEW-TRACEABILITY-ATTACHMENT-SENDING" | translate }}</label>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item" *ngFor="let traceability of traceabilities; let index=index">
              <span
                class="badge {{getBadgeClassBy(traceability.stateId)}}">{{'SELECT.OPTIONS.' + traceability._more.stateDescription | translate}}</span>
            {{traceability.createAt | dateformat}}<br>
            {{traceability._more.fullnameOperator}}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-outline-danger col-md-2 offset-md-2"
            aria-label="Left Align" (click)="accept()">
      {{ "BUTTON.ACCEPT" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading || loadingOperators || loadingTraceability || loadingUpdateTraceability"></app-loading>
